import React from 'react';
import { cn } from '@/lib/utils';
import { useLocale } from '../contexts/LocaleContext';
import { getAppLocale } from '../content/appLocale';

const LOCALE_LABELS = {
  'en-US': 'English (US)',
  'en-IN': 'English (India)',
};

export default function LocaleSelector({ className = '', variant = 'default' }) {
  const { locale, setLocale, supportedLocales } = useLocale();
  const copy = getAppLocale(locale);

  const selectClass =
    variant === 'menu'
      ? 'w-full rounded-md border border-[#3A3745] bg-[#0F0F14] px-2 py-2 text-sm text-[#F5F4FF] focus:border-[#7C5CFF] focus:outline-none'
      : 'rounded-md border border-[#3A3745] bg-[#111116] px-2 py-1 text-xs text-[#F5F4FF] focus:border-[#7C5CFF] focus:outline-none';

  const select = (
    <select
      aria-label={copy.common.localeLabel}
      value={locale}
      onChange={(event) => setLocale(event.target.value)}
      className={selectClass}
    >
      {supportedLocales.map((localeId) => (
        <option key={localeId} value={localeId}>
          {LOCALE_LABELS[localeId] || localeId}
        </option>
      ))}
    </select>
  );

  if (variant === 'menu') {
    return (
      <div className={cn('w-full min-w-[200px]', className)} onPointerDown={(e) => e.stopPropagation()}>
        {select}
      </div>
    );
  }

  return (
    <label className={cn('inline-flex items-center gap-2 text-xs text-[#B6B3C9]', className)}>
      <span className="shrink-0">{copy.common.localeLabel}</span>
      {select}
    </label>
  );
}
